import { reportRequestCreator } from 'serviceWorker/services/reports/createReportRequest';
import { getReportSignedUrl } from 'serviceWorker/services/reports';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { reportContract } from 'shared/domain/report/reportContract';

/** Answers report requests of the page. */
export function serveReportRequests(): ChannelUnsubscribe {
  return channelServer.handle(reportContract, {
    create: ({ report, uniqueId }) => reportRequestCreator.execute(report, uniqueId),
    getSignedUrl: getReportSignedUrl,
  });
}
